const TYPES = ['string', 'number', 'boolean', 'undefined', 'null', 'object', 'array']

class UrlFilter {
  static shiftValue(value) {
    if (typeof value === 'function') {
      return undefined
    }

    if (typeof value === 'object') {
      return encodeURIComponent(encodeURIComponent(JSON.stringify(value)))
    }

    if (typeof value === 'string') {
      return encodeURIComponent(encodeURIComponent(value))
    }
    return value
  }
  static shiftParams(params) {
    const spellArr = []
    for (const k in params) {
      if (Object.prototype.toString.call(params[k]) === '[object Array]') {
        if (params[k].length === 0) {
          continue
        }
      }
      if (Object.prototype.toString.call(params[k]) === '[object Object]') {
        if (Object.keys(params[k]).length === 0) {
          continue
        }
      }
      if (Object.prototype.toString.call(params[k]) === '[object String]') {
        if (params[k].length === 0) {
          continue
        }
      }
      spellArr.push(`${k}=${params[k]}`)
    }
    if (spellArr.length) {
      const data = spellArr.join('&')
      const url = window.location.href.split('?')[0]
      window.history.replaceState({}, '', `${url}?${data}`)
    } else {
      // 如果穿了一个空的数组，应该把url后面的参数清空
      window.history.replaceState({}, '', `${window.location.href.split('?')[0]}`)
    }
  }
  static expectValue(value, valueType, defaultValue) {
    let v = value
    switch (valueType) {
      case 'string':
        v = decodeURIComponent(decodeURIComponent(value))
        break

      case 'number':
        v = Number.isNaN(parseFloat(value)) ? defaultValue : parseFloat(value)
        break

      case 'boolean':
        if (value === 'true') {
          v = true
        } else if (value === 'false') {
          v = false
        } else {
          v = defaultValue
        }
        break

      case 'null':
        v = value === 'null' ? null : defaultValue
        break

      case 'undefined':
        v = value === 'undefined' ? undefined : defaultValue
        break

      case 'object':
      case 'array':
        try {
          v = JSON.parse(decodeURIComponent(decodeURIComponent(value)))
        } catch (err) {
          v = value
        }
        break

      default:
        v = null
    }

    return v
  }
  static desireValue(type) {
    switch (type) {
      case 'string':
        return ''
      case 'number':
        return undefined
      case 'boolean':
        return true
      case 'undefined':
        return undefined
      case 'null':
        return null
      case 'object':
        return {}
      case 'array':
        return []
    }
  }
  static getParams() {
    const href = window.location.href
    const params = {}
    if (href.includes('?')) {
      const splitData = href.split('?')[1]
      if (splitData) {
        const data = splitData.split('&')
        data.forEach(item => {
          if (item.includes('=')) {
            const i = item.indexOf('=')
            const key = item.substring(0, i)
            const value = item.substring(i + 1)
            let v = value
            if (value) {
              try {
                v = decodeURIComponent(value)
              } catch (err) {
                err && new Error(err.name)
              } finally {
                if (['', '[]', '{}'].includes(v) === false) {
                  params[key] = v
                }
              }
            }
          }
        })
      }
    }
    return params
  }

  /**
   * @description: 设置Url参数
   * @param {string, object} args 传入一个object或一个key与value
   * @returns {undefined} 返回值
   */
  set(...args) {
    if (!args.length) {
      return
    }
    if (['string', 'object'].includes(typeof args[0]) === false) {
      console.log(`URL_FILTER.set args[0]参数类型错误，仅支持['string', 'object']`)
      return
    }
    const params = UrlFilter.getParams()
    const [key, value] = args
    if (typeof key === 'string') {
      if (value) {
        if (Object.prototype.toString.call(value) === '[object Array]') {
          if (value.length === 0) {
            delete params[key]
            return
          }
        }
        if (Object.prototype.toString.call(value) === '[object Object]') {
          if (Object.keys(value).length === 0) {
            delete params[key]
            return
          }
        }
        if (Object.prototype.toString.call(value) === '[object String]') {
          if (value.length === 0) {
            delete params[key]
            return
          }
        }
        params[key] = UrlFilter.shiftValue(value)
      }
    } else {
      for (const k in key) {
        if (Object.prototype.toString.call(key[k]) === '[object Array]') {
          if (key[k].length === 0) {
            if (k in params) {
              Reflect.deleteProperty(params, k)
            }
            continue
          }
        }
        if (Object.prototype.toString.call(key[k]) === '[object Object]') {
          if (Object.keys(key[k]).length === 0) {
            if (k in params) {
              Reflect.deleteProperty(params, k)
            }
            continue
          }
        }
        if (Object.prototype.toString.call(key[k]) === '[object String]') {
          if (key[k].length === 0) {
            if (k in params) {
              Reflect.deleteProperty(params, k)
            }
            continue
          }
        }
        params[k] = UrlFilter.shiftValue(key[k])
      }
    }
    UrlFilter.shiftParams(params)
  }

  /**
   * @description: 获取Url中值
   * @param {string} name Url中的字段名
   * @param {string} valueType 期望值的类型
   * @param {string, number, boolean, undefined, null, object, array} defaultValue 默认值
   * @returns {string, number, boolean, undefined, null, object, array} 返回值
   */
  get(name, valueType = 'string', defaultValue = '') {
    if (TYPES.includes(valueType) === false) {
      console.error(`期望值类型错误，仅支持['string', 'number', 'boolean', 'undefined', 'null', 'object', 'array']`)
      return defaultValue
    }

    if (typeof name !== 'string') {
      return defaultValue
    }

    if (typeof defaultValue === 'function') {
      console.error(`默认值不支持function类型`)
      return UrlFilter.desireValue(valueType)
    }

    const parmas = UrlFilter.getParams()
    if (name in parmas) {
      return UrlFilter.expectValue(parmas[name], valueType, defaultValue)
    }

    return defaultValue
  }
}

const urlFilter = new UrlFilter()

export default urlFilter
